import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const MinusIcon = forwardRef<SVGSVGElement, IconProps>(function MinusIcon(
  { color = '', height = 18, width = 18, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 5.72386 3.14924 5.5 3.33333 5.5H8.66667C8.85076 5.5 9 5.72386 9 6C9 6.27614 8.85076 6.5 8.66667 6.5H3.33333C3.14924 6.5 3 6.27614 3 6Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
